import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";
import EMOJI_GROUPS from "unicode-emoji-json/data-by-group.json";

// Full Unicode emoji set, grouped + searchable. Shared by the chat composer
// (insert an emoji into the message) and the message reaction menu (react
// with any emoji). onPick receives the chosen emoji character.
export default function EmojiPicker({ onPick }) {
  const [q, setQ] = useState("");
  const query = q.trim().toLowerCase();
  const groups = useMemo(() => {
    if (!query) return EMOJI_GROUPS;
    return EMOJI_GROUPS
      .map((g) => ({
        ...g,
        emojis: g.emojis.filter(
          (e) =>
            (e.name || "").toLowerCase().includes(query) ||
            (e.slug || "").toLowerCase().includes(query)
        ),
      }))
      .filter((g) => g.emojis.length);
  }, [query]);
  return (
    <div className="w-[292px] bg-white border border-slate-200 rounded-sm shadow-xl flex flex-col" data-testid="emoji-picker">
      <div className="p-2 border-b border-slate-100">
        <div className="relative">
          <Search size={13} className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search emoji"
            className="w-full pl-7 pr-2 py-1.5 text-sm rounded-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300"
            data-testid="emoji-search"
          />
        </div>
      </div>
      <div className="overflow-y-auto p-2 space-y-2" style={{ maxHeight: 300 }}>
        {groups.map((g) => (
          <div key={g.slug}>
            <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-400 px-1 mb-1">{g.name}</div>
            <div className="grid grid-cols-8 gap-0.5">
              {g.emojis.map((e) => (
                <button
                  key={e.slug}
                  type="button"
                  title={e.name}
                  onClick={() => onPick(e.emoji)}
                  className="h-8 w-8 flex items-center justify-center text-[18px] leading-none rounded hover:bg-slate-100"
                  data-testid={`emoji-${e.slug}`}
                >
                  {e.emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
        {groups.length === 0 && <div className="text-xs text-slate-400 text-center py-6">No emoji found.</div>}
      </div>
    </div>
  );
}
